import API from "./API";

export interface ProfileUser {
 id: number;
 full_name: string;
 email: string;
 role: "ADMIN" | "PROJECT_MANAGER" | "EMPLOYEE";
 employee_code?: string | null;
 designation?: string | null;
 must_change_password: boolean;
 created_at: string;
}

export interface ActivityItem {
 action: string;
 entity_type: string | null;
 entity_id: string | null;
 created_at: string;
}

export interface LoginHistoryItem {
 created_at: string;
 ip_address: string | null;
 user_agent: string | null;
}

export interface RequestHistoryItem {
 request_id: number;
 requested_name: string;
 current_name: string;
 status: string;
 reviewed_by: number | null;
 reviewed_at: string | null;
 rejection_reason: string | null;
 created_at: string;
}

export interface ApiResponse<T> {
 success: boolean;
 data?: T;
 message?: string;
}

export const getProfile = async (): Promise<ProfileUser> => {
 const res = await API.get<ApiResponse<ProfileUser>>("/api/profile");
 if (!res.data.success || !res.data.data) {
 throw new Error(res.data.message ||"Failed to load profile");
 }
 return res.data.data;
};

export const changePassword = async (input: {
 oldPassword?: string;
 newPassword: string;
 confirmNewPassword: string;
}): Promise<void> => {
 const res = await API.post<ApiResponse<undefined>>("/api/profile/change-password",
 input
 );
 if (!res.data.success) {
 throw new Error(res.data.message ||"Failed to change password");
 }
};

export const requestNameChange = async (requestedName: string): Promise<void> => {
 const res = await API.post<ApiResponse<undefined>>("/api/profile/request-name-change",
 { requestedName }
 );
 if (!res.data.success) {
 throw new Error(res.data.message ||"Failed to request name change");
 }
};

export const getActivity = async (take = 10): Promise<ActivityItem[]> => {
 const res = await API.get<ApiResponse<ActivityItem[]>>(`/api/profile/activity?take=${take}`);
 if (!res.data.success || !res.data.data) {
 throw new Error(res.data.message ||"Failed to load activity");
 }
 return res.data.data;
};

export const getLoginHistory = async (take = 10): Promise<LoginHistoryItem[]> => {
 const res = await API.get<ApiResponse<LoginHistoryItem[]>>(`/api/profile/login-history?take=${take}`);
 if (!res.data.success || !res.data.data) {
 throw new Error(res.data.message ||"Failed to load login history");
 }
 return res.data.data;
};

export const getRequestHistory = async (): Promise<RequestHistoryItem[]> => {
 const res = await API.get<ApiResponse<RequestHistoryItem[]>>("/api/profile/request-history");
 if (!res.data.success || !res.data.data) {
 throw new Error(res.data.message ||"Failed to load request history");
 }
 return res.data.data;
};
